// Mock data for PFA AND ASSOCIATES LLP website

export const companyInfo = {
  name: "P F A AND ASSOCIATES LLP",
  tagline: "Clarity that Drives Commitment",
  tagline2: "Empowering business decisions with financial clarity",
  tagline3: "Driving growth through strategic insight",
  description: "Established in 2012, P F A and Associates LLP is a firm of Chartered Accountants built on the belief that professional excellence goes beyond numbers. We blend financial expertise with strategic vision to deliver innovative solutions in Assurance and Attestation, Applied Corporate Finance, Business Consulting, and Regulatory Advisory.",
  email: "info@teampfa.in",
  phone: "+91 98244 91429",
  address: "702 I Square Corporate Park, BH CIMS Hospital, Science City Road, Ahmedabad, Gujarat, India - 385555",
  foundedYear: 2012,
  vision: "To be a forward-looking firm that transforms professional services through innovation, integrity, and insight — creating lasting impact for our clients and community.",
  mission: "To deliver value-driven, technology-enabled, and transparent professional services that empower businesses to grow confidently and compliantly."
};

export const services = [
  {
    id: 1,
    title: "Assurance and Attestation Service",
    shortDesc: "Comprehensive assurance and attestation services ensuring financial transparency, accuracy, and regulatory compliance.",
    fullDesc: "We provide comprehensive assurance and attestation services to ensure financial transparency, accuracy, and regulatory compliance. Our audits deliver independent verification of financial statements and compliance with applicable standards, helping organizations build trust with stakeholders.",
    icon: "ShieldCheck",
    features: [
      "Statutory Audits",
      "Tax Audits",
      "Compliance Verification",
      "Financial Statement Audits",
      "Risk Assessment"
    ]
  },
  {
    id: 2,
    title: "Transaction Advisory",
    shortDesc: "Expert guidance on mergers, acquisitions, and strategic business transactions.",
    fullDesc: "Our transaction advisory team assists clients through complex business transactions, providing financial due diligence, valuation support, and strategic advisory services to maximize value and minimize risk.",
    icon: "TrendingUp",
    features: [
      "Mergers & Acquisitions",
      "Due Diligence",
      "Business Restructuring",
      "IPO Readiness Assessment",
      "Deal Structuring"
    ]
  },
  {
    id: 3,
    title: "Valuation Services",
    shortDesc: "Professional business and asset valuation services for various purposes.",
    fullDesc: "We provide independent, objective valuation services for businesses, intangible assets, and financial instruments. Our valuations are conducted using internationally recognized methodologies and standards.",
    icon: "Calculator",
    features: [
      "Business Valuation",
      "Intangible Asset Valuation",
      "Fair Value Assessment",
      "Purchase Price Allocation",
      "Impairment Testing"
    ]
  },
  {
    id: 4,
    title: "Internal Audit Services",
    shortDesc: "Strengthening internal controls and improving operational efficiency.",
    fullDesc: "Our internal audit services help organizations enhance their governance, risk management, and control processes. We provide objective assurance and advisory services designed to add value and improve operations.",
    icon: "FileCheck",
    features: [
      "Risk-based Auditing",
      "Operational Audits",
      "IT Audits",
      "Compliance Reviews",
      "Control Testing"
    ]
  },
  {
    id: 5,
    title: "Tax Advisory",
    shortDesc: "Strategic tax planning and compliance services for businesses and individuals.",
    fullDesc: "Our tax advisory team provides comprehensive tax planning, compliance, and consulting services, helping clients optimize their tax positions while ensuring full compliance with applicable laws and regulations.",
    icon: "Receipt",
    features: [
      "Corporate Tax Planning",
      "GST Compliance",
      "International Taxation",
      "Transfer Pricing",
      "Tax Litigation Support"
    ]
  },
  {
    id: 6,
    title: "Applied Corporate Finance Services",
    shortDesc: "Informed financial decisions that drive growth and enhance enterprise value.",
    fullDesc: "Our Applied Corporate Finance Services help businesses make informed financial decisions that drive growth, optimize capital structure, and enhance enterprise value. We combine analytical expertise with strategic insight to deliver practical financial solutions.",
    icon: "LineChart",
    features: [
      "Business Valuation",
      "Financial Modelling and Analysis",
      "Capital Structuring",
      "Fundraising Support",
      "Investment Advisory"
    ]
  },
  {
    id: 7,
    title: "GIFT-IFSCA Services",
    shortDesc: "Specialized advisory and compliance services for GIFT City operations under IFSCA framework.",
    fullDesc: "We offer specialized advisory and compliance services for entities operating within the Gujarat International Finance Tec-City (GIFT City) under the International Financial Services Centres Authority (IFSCA) framework. Our expertise ensures smooth registration, regulatory adherence, and efficient operations in this premier financial hub.",
    icon: "Building",
    features: [
      "IFSCA Registration & Licensing",
      "Regulatory Compliance",
      "Fund Management Advisory",
      "Banking Unit Setup",
      "International Tax Planning"
    ]
  }
];

export const practiceAreas = [
  {
    id: 1,
    name: "Infrastructure & Construction",
    description: "Comprehensive financial and compliance solutions for infrastructure developers and contractors."
  },
  {
    id: 2,
    name: "Corporate Sector",
    description: "Strategic advisory for corporate entities to enhance performance, efficiency, and governance."
  },
  {
    id: 3,
    name: "Manufacturing",
    description: "Specialized services for the manufacturing sector, focusing on cost optimization and compliance."
  },
  {
    id: 4,
    name: "Real Estate & Development",
    description: "Comprehensive advisory for real estate developers, investors, and project companies."
  },
  {
    id: 5,
    name: "Technology & Startups",
    description: "Tailored solutions for technology companies and emerging startups."
  },
  {
    id: 6,
    name: "Healthcare",
    description: "Specialized accounting, audit, and compliance support for hospitals and healthcare providers."
  },
  {
    id: 7,
    name: "Education & Non-Profits",
    description: "Governance, audit, and compliance support for educational institutions and NGOs."
  },
  {
    id: 8,
    name: "Trading & Distribution",
    description: "Business solutions for trading, logistics, and distribution networks."
  }
];

export const team = [
  {
    id: 1,
    name: "CA Prasad Akhani",
    designation: "Partner",
    qualification: "FCA",
    experience: "15+ years",
    specialization: "M&A Advisory, Fund Raising Service",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHN8ZW58MHx8fHwxNzYyMTQ2MDE5fDA&ixlib=rb-4.1.0&q=85",
    linkedin: "https://www.linkedin.com/in/ca-prasad-akhani-0a593022/?originalSubdomain=in"
  },
  {
    id: 2,
    name: "CA Kenil Thakkar",
    designation: "Partner",
    qualification: "FCA, DISA(ICAI)",
    experience: "12+ years",
    specialization: "Business Valuation, Applied Corporate Finance, Internal Auditing",
    image: "https://images.unsplash.com/photo-1624010152415-4e381a6d55af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBwb3J0cmFpdHN8ZW58MHx8fHwxNzYyMTQ2MDI5fDA&ixlib=rb-4.1.0&q=85",
    linkedin: "https://www.linkedin.com/in/kenil-thakkar-742826106/?originalSubdomain=in"
  },
  {
    id: 3,
    name: "CA Niranjan Gupta",
    designation: "Partner",
    qualification: "ACA",
    experience: "10+ years",
    specialization: "Assurance and Attestation, Tax Advisory",
    image: "https://images.unsplash.com/photo-1652471943570-f3590a4e52ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHN8ZW58MHx8fHwxNzYyMTQ2MDE5fDA&ixlib=rb-4.1.0&q=85",
    linkedin: "https://www.linkedin.com/in/ca-niranjan-gupta-a72197252/"
  }
];

export const resources = [
  {
    id: 1,
    title: "Understanding the New GST Amendments 2024",
    category: "Tax Updates",
    date: "2024-03-15",
    excerpt: "A comprehensive guide to the latest GST amendments and their impact on businesses.",
    author: "CA Amit Sharma"
  },
  {
    id: 2,
    title: "Key Considerations for Business Valuation in M&A",
    category: "Valuation",
    date: "2024-03-10",
    excerpt: "Essential factors to consider when valuing businesses for merger and acquisition transactions.",
    author: "CA Fahim Khan"
  },
  {
    id: 3,
    title: "Internal Audit Best Practices for SMEs",
    category: "Audit",
    date: "2024-03-05",
    excerpt: "Implementing effective internal audit frameworks for small and medium enterprises.",
    author: "CA Sneha Patel"
  },
  {
    id: 4,
    title: "Transfer Pricing Documentation Requirements",
    category: "Tax Updates",
    date: "2024-02-28",
    excerpt: "A detailed overview of transfer pricing documentation requirements for Indian companies.",
    author: "CA Amit Sharma"
  },
  {
    id: 5,
    title: "Financial Due Diligence in Startup Investments",
    category: "Advisory",
    date: "2024-02-20",
    excerpt: "Key aspects of financial due diligence when investing in startups and emerging companies.",
    author: "CA Rajesh Kumar"
  },
  {
    id: 6,
    title: "Companies Act 2013: Recent Amendments",
    category: "Compliance",
    date: "2024-02-15",
    excerpt: "Important amendments to the Companies Act 2013 and their implications for businesses.",
    author: "CA Pradeep Agarwal"
  }
];

export const whyChooseUs = [
  {
    title: "Integrity",
    description: "Upholding trust and ethics in every engagement."
  },
  {
    title: "Excellence",
    description: "Pursuing quality and precision relentlessly."
  },
  {
    title: "Innovation",
    description: "Thinking beyond conventions to create better solutions."
  },
  {
    title: "Commitment",
    description: "Delivering with dedication and accountability."
  },
  {
    title: "Client Focus",
    description: "Building relationships rooted in understanding and trust."
  },
  {
    title: "Collaboration",
    description: "Achieving collective success through teamwork and respect."
  }
];
